/* eslint-disable no-console */
import { encodeKebabCase } from '../../../utils/string-utils';
import { updateContentHeight } from '../../content-toggle';

const getModelContentDivByName = (name) => {
  const id = encodeKebabCase(name);
  return document.querySelector(`[aria-controls="${id}-content"]`);
};

const showModelByName = (name) => {
  const id = encodeKebabCase(name);
  const btn = document.querySelector(`[aria-controls="${id}-content"]`);
  const content = document.getElementById(`${id}-content`);
  btn.setAttribute('aria-expanded', 'true');
  content.classList.add('expand-content');
  updateContentHeight();
};

const showFirstModel = () => {
  const btn = document.querySelectorAll('#pricingContentWrapper .content-toggle-btn')[0];
  const content = document.querySelectorAll('#pricingContentWrapper .content-toggle-content')[0];
  btn.setAttribute('aria-expanded', 'true');
  content.classList.add('expand-content');
  updateContentHeight();
};

const hideAllModels = () => {
  const btnList = document.querySelectorAll('#pricingContentWrapper .content-toggle-btn');
  const contentList = document.querySelectorAll('#pricingContentWrapper .content-toggle-content');
  [].map.call(btnList, (btn) => {
    btn.setAttribute('aria-expanded', 'false');
  });
  [].map.call(contentList, (content) => {
    content.classList.remove('expand-content');
  });
  updateContentHeight();
};

const updateModelButtonLabels = (state) => {
  const { active, series } = state;
  const { element, option } = active;
  const btnList = document.querySelectorAll(`[data-awning-option="${option}"]`);
  [].map.call(btnList, (btn) => {
    const size = btn.getAttribute('data-size');
    if (btn === element) {
      btn.classList = 'button-transparent';
      btn.textContent = `${size}ft. Awning Selected`;
      btn.closest('tr').classList.add('active');
    } else {
      let selector = 'button-reset button-dark-blue-lg';
      if (series === 'SunSetter Series Awnings') {
        selector = 'button-reset button-light-yellow-lg';
      }
      btn.classList = selector;
      btn.textContent = `Build My ${size}ft. Awning`;
      btn.closest('tr').classList.remove('active');
    }
  });
};

const getModels = (series, hidePrices) => {
  const url = `GetModelSizesBySeries?series=${series}&hidePrices=${hidePrices}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const getModelSteps = (code) => {
  const url = `GetAvailableStepsByModelCode?code=${code}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};
// Need to passback scope (this)
const getModelDataByCode = (code, callback, scope) => {
  getModelSteps(code)
    .then((data) => {
      if (callback) {
        callback(data, scope);
      }
    });
};

const updateModelsBySeries = (state, callback) => {
  const { hidePrices } = window;
  const { series } = state;
  const wrapper = document.getElementById('pricingContentWrapper');
  wrapper.classList.add('updating');
  wrapper.classList.add('updating-content');
  getModels(series, hidePrices)
    .then((data) => {
      wrapper.classList.remove('updating');
      wrapper.classList.remove('updating-content');
      wrapper.innerHTML = data;
      updateContentHeight();
      if (callback !== null) {
        callback();
      }
    });
};

export {
  getModelContentDivByName,
  getModelDataByCode,
  hideAllModels,
  showFirstModel,
  showModelByName,
  updateModelButtonLabels,
  updateModelsBySeries,
};
/* eslint-enable no-console */
